import { render, staticRenderFns } from "./FormToReceive.vue?vue&type=template&id=2fade036&"
import script from "./FormToReceive.vue?vue&type=script&lang=js&"
export * from "./FormToReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports